<template>
    <div v-if="isUnderReview || isReject" class="alarm-msg" :class="{'is-watting': isUnderReview, 'is-reject': isReject, 'active': verifiedBling}">
        <img src="@/assets/img/icon/info_white.svg" alt="">
        <span v-if="isUnderReview">企業認證審核中，暫時無法進行任何操作</span>
        <span v-if="isReject">企業認證審核未通過，<span class="link" @click="$router.push({name: 'bizBussinessVerified'})">查看詳情</span></span>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
        }
    },
    watch: {
        verifiedStatus: {
            handler: function (val) {
                if(val  === 'UNDER_REVIEW' || val === 'REJECT'){
                    localStorage.setItem('isGuided', false)
                }
            },
            immediate: true
        }
    },
    computed: {
        isUnderReview: function () {
            if(this.verifiedStatus === 'UNDER_REVIEW'){
                return true
            }else{
                return false
            }
        },
        isReject: function () {
            if(this.verifiedStatus === 'REJECT'){
                return true
            }else{
                return false
            }
        },
        ...mapGetters({
            verifiedStatus: 'GET_BIZ_COMPANY_IS_VERIFIED',
            verifiedBling: 'GET_BIZ_VERIFIED_BLING'
        })
    },
}
</script>
<style lang="scss"  >
    .alarm-msg{
        position: fixed;
        top: 60px;
        height: 48px;
        padding: 11px 24px 12px 16px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        z-index: 10;
        box-sizing: border-box;
        font-size: 16px;
        font-weight: 500;
        left: 50%;
        color: #ffffff;
        img{
            margin-right: 4px;
        }
        &.is-watting{
            width: 356px;
            background-color:#fcb773;
            margin-left: -178px;
            &.active{
                box-shadow: 0 2px 10px 2px rgba(255, 200, 0, 0.3);
                background-color: #ffc925;
            }
        }
        &.is-reject{
            width: 292px;
            background-color:#fc7171;
            margin-left: -144px;
            .link{
                cursor: pointer;
                text-decoration: underline;
            }
            &.active{
                box-shadow: 0 2px 10px 2px rgba(255, 0, 0, 0.3);
                background-color: #ff4848;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/alarms/verifiedStatusAlarm.vue